// Client-side cooldown for AI training questions the user has dismissed. Keeps the pending-training
// banner from re-appearing every time the AI is chatty. Two-part key strategy so the AI can't
// bypass the cooldown by changing its training_context slug: we stash BOTH the slug AND a
// normalised version of the question text, and any cold-start `settings.pending_training` match
// against either key silently re-clears server-side.

const STORAGE_KEY = "meye_training_skip";
const COOLDOWN_MS = 7 * 86_400_000; // 7 days

const normQuestion = (q) => String(q || "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim().slice(0, 120);

const readMap = () => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}") || {}; } catch { return {}; }
};
const writeMap = (m) => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(m)); } catch { /* private mode */ }
};

/** Called from the AIChatBar's Skip/Dismiss buttons. Stashes both a context-slug key and a
 *  question-text key so the AI can't wriggle around it by renaming the context. */
export const stashTrainingSkip = (pt) => {
    if (!pt || (!pt.context && !pt.question)) return;
    const map = readMap();
    const now = Date.now();
    if (pt.context) map[`ctx:${pt.context}`] = now;
    if (pt.question) map[`q:${normQuestion(pt.question)}`] = now;
    writeMap(map);
};

/** Returns true when either the context slug OR the normalised question was skipped within the
 *  last 7 days. Anything older is treated as unskipped (and cleaned up on next write). */
export const isTrainingSkipped = (pt) => {
    if (!pt || (!pt.context && !pt.question)) return false;
    const map = readMap();
    const now = Date.now();
    const keys = [];
    if (pt.context) keys.push(`ctx:${pt.context}`);
    if (pt.question) keys.push(`q:${normQuestion(pt.question)}`);
    return keys.some((k) => {
        const ts = map[k];
        return typeof ts === "number" && now - ts < COOLDOWN_MS;
    });
};
